var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.65 21.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffff;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:#e8432a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.25,
    y: 0.25,
    width: 21.15,
    height: 21.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.88 13.91 15.88 7.78 12.43 10.78 15.88 13.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.78 7.65 5.78 7.66 5.78 13.86 9.22 10.74 5.78 7.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.45,10.89l4.11-3.57H6.23l4,3.56A.92.92,0,0,0,11.45,10.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.82,11.31a1.46,1.46,0,0,1-1,.37,1.5,1.5,0,0,1-1-.38l-.21-.19L6.08,14.33h9.45L12,11.15Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.54d40c17586d2fca4c6a10f8d8f19122.svg";
export { ForwardRef as ReactComponent };